import { dataAttribute, DataAttributes, Link, Stack } from "@bps/fluent-ui";
import { Statement } from "@stores/billing/models/Statement.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const TransactionActionCell: React.FC<{
  statement: Statement;
}> = ({ statement }) => {
  const { billing } = useStores();

  const viewStatementLink = (
    <Link
      onClick={() => {
        billing.openStatementPdf(statement.id);
        billing.ui.setStatementDocumentPreviewData({
          contactId: statement.accountContactId,
          statementId: statement.id,
          statement
        });
      }}
      {...dataAttribute(DataAttributes.Element, "statement-link")}
    >
      View
    </Link>
  );

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
      {viewStatementLink}
    </Stack>
  );
};
